import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useQuery } from '#lib/hooks/use-query.js';

async function fetchCountries() {
    const response = await fetchAndParse(`${API_URL}/o/countries`, {
        headers: { ...jsonHeaders }
    });
    return response;
}

export default function useCountries() {
    const { data, ...flags } = useQuery({
        queryKey: ['countries'],
        queryFn: fetchCountries,
        refetchOnFocus: false
    });

    return { data, flags };
}
